import { defineStore } from "pinia";
import { useStorage } from "@vueuse/core"; // Import useLocalStorage

// main is the name of the store. It is unique across your application
// and will appear in devtools
export const useNavStore = defineStore("navigation", {
  // a function that returns a fresh state
  state: () => ({
    mobileNavOpen: false,
    previousRoute: useStorage("previousRoute", {}), // Use useLocalStorage for persistence
  }),
  // optional getters
  getters: {
    // getters receive the state as first parameter
    currentMobileNavStatus: (state) => state.mobileNavOpen,
    getPreviousRoute: (state) => state.previousRoute, // Getter for previousRoute
  },
  // optional actions
  actions: {
    closeMobileNav() {
      // `this` is the store instance
      this.mobileNavOpen = false;
    },
    openMobileNav() {
      // `this` is the store instance
      this.mobileNavOpen = true;
    },
    toggleMobileNav() {
      // `this` is the store instance
      this.mobileNavOpen = !this.mobileNavOpen;
    },
    setPreviousRoute(route) {
      this.previousRoute = route; // Action to set previousRoute
    },
    clearPreviousRoute() {
      this.previousRoute = {}; // Action to clear previousRoute
    },
  },
});
